<ion-card class="ion-no-margin ion-margin-horizontal mart10 pad10 bg-white">
  <ion-label>
    <ion-grid class="ion-no-padding padb5" fixed>
      <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding" size="8">
          <div class="service-header">
            <img
              class="marb10 logo"
              [src]="itemInfo?.img"
              *ngIf="itemInfo?.img && isIconVisible"
            />
            <p class="line-2-clip fs-4 font600 card-primary-text-color">
              {{ itemInfo?.title }}
            </p>
          </div>
          <ion-label>
            <span
              class="primary-price-color fs-2 font600"
              *ngIf="itemInfo?.finalPrice"
            >
              {{ itemInfo?.finalPrice | currency : itemInfo?.currency }}
            </span>
            <span
              class="strike-price-color fs-1 font600"
              *ngIf="itemInfo?.finalPrice !== itemInfo?.origPrice"
            >
              {{ itemInfo?.origPrice | currency : itemInfo?.currency }}
            </span>
            <ion-text
              class="marl4 fs-1 font600 primary-price-color"
              *ngIf="itemInfo?.tag || itemInfo?.campaigns?.[0]?.offerTitle"
            >
              <span
                >({{ itemInfo?.tag || itemInfo?.campaigns?.[0]?.offerTitle
                }})</span
              >
            </ion-text>
          </ion-label>
        </ion-col>
        <ion-col class="ion-no-padding" size="4">
          <ion-button
            class="secondary-btn book l-spacing0"
            (click)="bookNow(itemInfo)"
            expand="block"
          >
            {{ "meet_and_greet.meet_and_greet_home.book_now_btn" | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-accordion-group value="numbers" *ngIf="itemInfo?.desc">
      <ion-accordion value="open">
        <ion-item class="ion-no-padding ion-no-margin" slot="header" (click)="openAccordion()">
          <ion-label class="fs-2 font600 accordian-title-text-color">{{
            "meet_and_greet.meet_and_greet_home.read_more_btn" | translate
          }}</ion-label>
        </ion-item>

        <div slot="content">
          <p
            class="fs-2 font400 accordian-subtitle-text-color"
            [innerHtml]="itemInfo?.desc"
          ></p>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </ion-label>
</ion-card>
